// najdeme na stránce všechny podřízené selectboxy

class DependentSelect {
    init() {
        this.initComponent();
    }

    initComponent() {
        this.initSelectVisibility();

        document.querySelectorAll('select[data-depends]').forEach((childSelect) => {
            if (childSelect.dataset.dependentSelectInitialized) {
                return;
            }
            childSelect.dataset.dependentSelectInitialized = 'true';

            let parentSelect = childSelect.form[childSelect.dataset.depends]; // nadřízený <select>
            let url = childSelect.dataset.url; // atribut data-url
            let items = JSON.parse(childSelect.dataset.items || 'null'); // atribut data-items

            // Handling Select2 change event
            if ($(parentSelect).hasClass('select2-init')) {
                $(parentSelect).on('select2:select', () => {
                    this.triggerChangeEvent(childSelect, parentSelect, items, url);
                });
            }

            parentSelect.addEventListener('change', () => {
                this.triggerChangeEvent(childSelect, parentSelect, items, url);
            });
            this.triggerChangeEvent(childSelect, parentSelect, items, url);
        });
    }

    initSelectVisibility() {
        document.querySelectorAll('[data-select-visibility]').forEach((element) => {
            if (element.dataset.visibilityInitialized) {
                return;
            }
            element.dataset.visibilityInitialized = 'true';

            let selectId = element.dataset.selectVisibility;
            let select = document.getElementById(selectId);

            if (!select && selectId.startsWith('#')) {
                select = document.getElementById(selectId.substring(1));
            } else if (!select) {
                try {
                    select = document.querySelector(selectId);
                } catch (e) {}
            }

            if (select) {
                const checkVisibility = () => {
                    if (select.value && select.value !== '0') {
                        element.classList.remove('d-none');
                    } else {
                        element.classList.add('d-none');
                    }
                };

                if ($(select).hasClass('select2-init')) {
                    $(select).on('select2:select select2:unselect select2:clear', checkVisibility);
                }

                select.addEventListener('change', checkVisibility);
                select.addEventListener('visibility-check', checkVisibility);
                checkVisibility();
            }
        });
    }

    triggerChangeEvent(childSelect, parentSelect, items, url) {
        if (items) {
            this.updateSelect(childSelect, items[parentSelect.value]);
        }

        if (url) {
            fetch(url.replace(encodeURIComponent('#'), encodeURIComponent(parentSelect.value)))
                .then((response) => response.json())
                .then((data) => this.updateSelect(childSelect, data));
        }
    }

    addPrompt(select)
    {
        let prompt = $(select).attr('data-prompt') ?? null;
        if (typeof prompt === 'string' && prompt.trim() !== '') {
            let promptOption = document.createElement('option');
            promptOption.setAttribute('value', '0');
            promptOption.innerText = prompt;
            select.appendChild(promptOption);
            select.selectedIndex = 0;
        }
    }

    updateSelect(select, items) {
        let currentValue = select.value;
        select.innerHTML = '';
        this.addPrompt(select);

        let defaultValue = items['#default#'] ?? null;
        defaultValue = $(select).attr('data-default-value') ?? defaultValue;

        const keysWithoutDefault = Object.keys(items).filter(k => k !== '#default#');
        let prompt = $(select).attr('data-prompt') ?? null;
        if (keysWithoutDefault.length === 1 && (prompt === null || prompt.trim() === '')) {
            defaultValue = keysWithoutDefault[0];
        }

        let entries = Object.entries(items).filter(([id]) => id !== '#default#');

        let orderby = $(select).attr('data-orderby') ?? null;
        if (orderby !== null) {
            entries.sort((a, b) => {
                // a[1] / b[1] jsou texty
                return String(a[1]).localeCompare(String(b[1]), 'cs', { sensitivity: 'base' });
            });
        }

        let value = $(select).attr('data-value') ?? null;
        if (value !== null) {
            $(select).removeAttr('data-value');
        } else {
            value = currentValue;
        }

        for (const [id, text] of entries) {
            let el = document.createElement('option');
            el.value = id;

            if (String(id) === String(value) || (value === null && String(id) === String(defaultValue))) {
                el.selected = true;
            }

            el.textContent = text;
            select.appendChild(el);
        }

        if (String(value) === '0') {
            select.value = '0';
        }

        let disabledIfEmpty = $(select).attr('data-disabled-if-empty') ?? false;
        if (disabledIfEmpty !== false) {
            select.disabled = entries.length <= 0;
        }

        let disabled = $(select).attr('data-disabled') ?? false;
        if (disabled !== false) {
            select.disabled = true;
        }
    }

    initialize(naja) {
        naja.addEventListener('complete', this.initComponent.bind(this));
        naja.addEventListener('interaction', this.initComponent.bind(this));
        window.addEventListener('DOMContentLoaded', this.initComponent.bind(this));

    }
}

export default DependentSelect;
